const DetailRowsTable = ({ rows = [] }) => (
  <table className="pdf-table-striped pdf-w-100">
    <tbody>
      {rows.map(([serial, label, value]) => (
        <tr key={serial}>
          <td className="pdf-w-5">{serial}</td>
          <td className="pdf-w-20">{label}</td>
          <td className="pdf-w-5">:</td>
          <td className="pdf-w-70">{value}</td>
        </tr>
      ))}
    </tbody>
  </table>
)

export default DetailRowsTable
